module.exports = __webpack_public_path__ + "img/finalizado.c87e7a65.jpg";